import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ErrorsService } from './core/services/errors/errors.service';
import { GlobalLoaderService } from '@core/services/global-loader.service';
import { AuthService } from '@auth0/auth0-angular';
import { filter, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public title = 'cs-platform';
  public constructor(
    public errorService: ErrorsService,
    public globalLoaderService: GlobalLoaderService,
    private auth: AuthService,
    private router: Router,
  ){}
  
  async ngOnInit() {
    // Scroll to top on every route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0 });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });

    // Handle the redirect and retrieve custom data from appState$
    const auth0State = await firstValueFrom(this.auth.appState$)
    // Redirect to the intended page with query parameters
    if (auth0State.redirect) {
      window.location.href = auth0State.redirect;
    }
  }
}
